'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');

var Resizer = React.createClass({
  propTypes: {
    value: React.PropTypes.number.isRequired,
    onChange: React.PropTypes.func.isRequired,
  },
  getInitialState: function () {
    return {
      value: this.props.value
    };
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      value: nextProps.value
    });
  },
  componentDidMount: function () {
    this.$deviceDom = $('#device');
    var range = $(".custom-resizer > input");
    range.change(this.onChange);
  },
  componentDidUpdate: function () {
    this.$deviceDom.css('transform', 'scale(' + this.state.value + ')');
  },
  render: function () {
    return (
      <div className="custom-resizer">
        <input type="range"  value={this.state.value * 100} min="30" max="300" onChange={this.onChange}/>
      </div>
    );
  },
  onChange: function (e) {
    clearTimeout(this.timer);
    var val = parseFloat(parseInt(e.target.value, 10) / 100);
    this.$deviceDom.css('transform', 'scale(' + val + ')');
    this.setState({
      value: val
    });
    var self = this;
    this.timer = setTimeout(function () {
      self.props.onChange(val);
    }, 200);
  }
});

module.exports = Resizer;


// WEBPACK FOOTER //
// ./src/views/Resizer.jsx